var clearSlide = function clearSlide(element) {
  element.style.transitionDuration = '';
  element.classList.remove('k-slide-down-appear', 'k-slide-down-appear-active', 'k-slide-down-exit', 'k-slide-down-exit-active', 'k-slide-up-appear', 'k-slide-up-appear-active', 'k-slide-up-exit', 'k-slide-up-exit-active');
};

var firefox = typeof window !== 'undefined' && /Firefox/.test(window.navigator.userAgent);
/**
 * @hidden
 */

export var slide = function slide(element, direction, duration, type, callback) {
  if (duration === 0) {
    return callback();
  }

  var slideClass = 'k-slide-' + direction + '-' + type;
  var slideActiveClass = slideClass + '-active';

  var transitionend = function transitionend() {
    // if event is attached using react,
    // the animation does not work well in firefox,
    // when the show/hide button is toggled quickly.
    element.removeEventListener('transitionend', transitionend);
    clearSlide(element);
    callback();
  };

  element.addEventListener('transitionend', transitionend);

  var animate = function animate() {
    clearSlide(element);
    element.classList.add(slideClass);
    window.requestAnimationFrame(function () {
      element.style.transitionDuration = duration + 'ms';
      element.classList.add(slideActiveClass);
    });
  };

  if (firefox) {
    window.requestAnimationFrame(animate);
  } else {
    animate();
  }
};